var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMitigation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 4.5L8.7856 0.828334C8.85218 0.797369 8.92558 0.78125 9 0.78125C9.07442 0.78125 9.14782 0.797369 9.2144 0.828334L17.25 4.45468",
    stroke: "#6E8CA0",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7.40428V15.6197C16 15.9858 15.8282 16.3369 15.5224 16.5957C15.2166 16.8546 14.8019 17 14.3694 17H3.6306C3.19814 17 2.78339 16.8546 2.47759 16.5957C2.17179 16.3369 2 15.9858 2 15.6197L2.00001 7",
    stroke: "#6E8CA0",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5575 7.51438L9.5 6.5C9.17024 6.42627 8.82416 6.42714 8.49441 6.50086L6.44235 7.51438C6.31331 7.54247 6.19921 7.60765 6.11884 7.6992C6.03847 7.79076 5.99663 7.90321 6.00021 8.01803C6.16664 12.3354 8.99995 13 8.99995 13C8.99995 13 11.8333 12.3354 11.9997 8.01803C12.0087 7.78178 11.8222 7.57409 11.5575 7.51438Z",
    stroke: "#6E8CA0",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMitigation);
export default __webpack_public_path__ + "static/media/mitigation.4ac8c8769bcefc98c206678f70729e4a.svg";
export { ForwardRef as ReactComponent };